export default __webpack_public_path__ + "static/media/IMG_1277.62746b2b.jpg";